import { render, staticRenderFns } from "./ContentAdvisoryModal.vue?vue&type=template&id=addfb9d2&"
import script from "./ContentAdvisoryModal.vue?vue&type=script&lang=js&"
export * from "./ContentAdvisoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports